import { LitElement, TemplateResult, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './nuvance-cookie-management.global.pcss?inline';
import innerStyles from './nuvance-cookie-management.inner.pcss?inline';
import CookieHelper from '../../utilities/cookie-helper';

/**
 * The Nuvance Cookie Management component
 * @element nuvance-cookie-management
 *
 * @slot - Slot for cookie management content.
 */
@customElement('nuvance-cookie-management')
export class NuvanceCookieManagement extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });

  /**
   * Internal state to track if the cookie banner was acknowledged.
   */
  @state()
  private isAcknowledged = false;

  /**
   * Event listener for the cookie management acknowledge button.
   */
  private closeCookieManagementHandler = this.closeCookieManagement.bind(this);

  /**
   * Event listener for the cookie management acknowledge button.
   */
  private cookieManagementButton: Element | null = null;

  connectedCallback(): void {
    super.connectedCallback();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    this.cookieManagementButton?.removeEventListener(
      'click',
      this.closeCookieManagementHandler
    );
  }

  firstUpdated() {
    const privacyCookie = CookieHelper.getCookie('privacy-notification');

    if (privacyCookie) {
      this.isAcknowledged = true;
    } else {
      this.cookieManagementButton = this?.querySelector(
        '#cookie-management-acknowledge'
      );

      this.cookieManagementButton?.addEventListener(
        'click',
        this.closeCookieManagementHandler
      );
    }
  }

  closeCookieManagement(event: Event) {
    event.preventDefault();

    CookieHelper.setCookie('privacy-notification', '1', 365);

    this.isAcknowledged = true;
  }

  render(): TemplateResult {
    return html`
      ${!this.isAcknowledged
        ? html` <div class="cookie-management">
            <div class="cookie-management--content-wrapper">
              <div class="cookie-management--content">
                <slot></slot>
              </div>
            </div>
          </div>`
        : nothing}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nuvance-cookie-management': NuvanceCookieManagement;
  }
}
